import React from "react";
import { Box } from "@mui/material";
import FrameCard from "../../shared/FrameCard";
import SectionTitle from "../../shared/SectionTitle";
import HumanSkillRadar from "./HumanSkillRadar";
import HumanSkillDescriptions from "./HumanSkillDescriptions";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";

// ヒューマンスキルのMax値
const MAX_HUMAN_SKILL_SCORE = 6;

/**
 * ヒューマンスキル全体セクション
 */
const HumanSkillSection = ({ humanSkills }) => {
  const isDesktop = useIsDesktop();
  return (
    <FrameCard>
      <SectionTitle title="ヒューマンスキル" />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr",
          gap: 3,
          alignItems: "center",
        }}
      >
        <HumanSkillRadar
          humanSkills={humanSkills}
          maxScore={MAX_HUMAN_SKILL_SCORE}
        />
        <HumanSkillDescriptions humanSkills={humanSkills} />
      </Box>
    </FrameCard>
  );
};

export default HumanSkillSection;
